import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { fetchProductHistory, fetchProducts } from "../slices/productSlice";

export const useProducts = () => {
    const dispatch = useAppDispatch();
    const { products, loading, error, success, productHistory } = useAppSelector((state) => state.products);

    useEffect(() => {
        dispatch(fetchProducts());
        dispatch(fetchProductHistory());
    }, [dispatch]);

  return { products, loading, error, success, productHistory };
};